import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock, LogOut, MessageSquare, Mail } from "lucide-react";

// Shown only when an account has been disabled by the admin.
export default function CodeGate() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div className="min-h-screen bg-surface flex justify-center">
      <div className="w-full max-w-md min-h-screen flex flex-col px-6 pt-14 pb-8 relative overflow-hidden">
        <div className="absolute -top-24 -right-20 w-56 h-56 rounded-full bg-brandTertiary/70 blur-2xl" />
        <div className="relative flex-1 flex flex-col">
          <div className="w-16 h-16 rounded-[20px] bg-brandPrimary flex items-center justify-center mb-6 relative">
            <Lock size={28} className="text-onBrand" />
          </div>
          <h1 data-testid="disabled-title" className="font-heading text-3xl font-extrabold text-onSurface leading-tight">Account paused</h1>
          <p className="text-base text-muted-foreground mt-2 max-w-sm">Your Docket account has been paused. Please get in touch and we'll get you back up and running.</p>

          <div className="mt-6 bg-surfaceSecondary border border-border rounded-[16px] p-4">
            <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-2">Get in touch</p>
            <a href="sms:+447305510378" data-testid="contact-sms" className="flex items-center gap-2.5 py-2 text-sm font-semibold text-onSurface"><MessageSquare size={16} className="text-brandPrimary" /> Message +44 7305 510378</a>
            <a href="mailto:kaigalb30@gmail.com" data-testid="contact-email" className="flex items-center gap-2.5 py-2 text-sm font-semibold text-onSurface"><Mail size={16} className="text-brandPrimary" /> kaigalb30@gmail.com</a>
          </div>

          <div className="mt-auto pt-8">
            <button data-testid="code-logout" onClick={() => { logout(); navigate("/"); }} className="w-full text-sm font-semibold text-muted-foreground flex items-center justify-center gap-1.5 py-2">
              <LogOut size={15} /> Sign out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
